import { Button, CardActions, CardContent, Grid, MenuItem, Modal, Select, Typography } from '@mui/material';
import { ConfirmCard } from './Styles';
import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';
import AddIcon from '@mui/icons-material/Add';
import { LineSiteInfo } from '../../@types/lines';
import { useState } from 'react';

interface AddNewLineSiteModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (siteInfo: LineSiteInfo) => void;
    lineSites: LineSiteInfo[];
}

export default function AddNewLineSiteModal({ open, onClose, onSave, lineSites }: AddNewLineSiteModalProps) {
    const [selectedLineSite, setSelectedLineSite] = useState<LineSiteInfo | null>(null);

    return (
        <Grid>
            <Modal open={open} onClose={onClose}>
                <ConfirmCard>
                    <CardContent sx={{ p: 2 }}>
                        <Typography variant={'h5'} pb={3}>
                            Járathoz gyár hozzáadása
                        </Typography>
                        <Typography paragraph>Válaszd ki a gyárat, amelyiket hozzá akarod adni a járathoz.</Typography>
                        <Select
                            fullWidth
                            value={selectedLineSite?.Name || ''}
                            onChange={e => {
                                const selected = lineSites.find(site => site.Name === e.target.value);
                                setSelectedLineSite(selected || null);
                            }}>
                            {lineSites.map(site => (
                                <MenuItem key={site.Name} value={site.Name}>
                                    {site.Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </CardContent>
                    <CardActions sx={{ justifyContent: 'space-between' }}>
                        <Button
                            sx={{ mx: 1, borderRadius: 50 }}
                            variant={'contained'}
                            size={'small'}
                            color={'info'}
                            onClick={() => onClose()}
                            startIcon={<ArrowBackIosNewTwoToneIcon />}>
                            Mégsem
                        </Button>
                        <Button
                            sx={{ mx: 1, borderRadius: 50 }}
                            variant={'contained'}
                            size={'small'}
                            color={'success'}
                            disabled={!selectedLineSite}
                            onClick={() => {
                                if (selectedLineSite) {
                                    onSave(selectedLineSite);
                                }
                            }}
                            endIcon={<AddIcon />}>
                            Hozzáadás
                        </Button>
                    </CardActions>
                </ConfirmCard>
            </Modal>
        </Grid>
    );
}
